module.exports = __webpack_public_path__ + "img/bronco21.ede3c666.png";